"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var shallowequal_1 = __importDefault(require("shallowequal"));

exports.useIntersection = function (target, options, callback) {
  if (options === void 0) {
    options = {};
  }

  var defaultIntersecting = options.defaultIntersecting,
      once = options.once,
      opts = __rest(options, ["defaultIntersecting", "once"]);

  var optsRef = react_1.useRef(opts);

  var _a = react_1.useState(defaultIntersecting === true),
      intersecting = _a[0],
      setIntersecting = _a[1];

  var intersectedRef = react_1.useRef(false);
  react_1.useEffect(function () {
    if (!shallowequal_1.default(optsRef.current, opts)) {
      optsRef.current = opts;
    }
  });
  react_1.useEffect(function () {
    if (target == null) {
      return;
    }

    var element = target instanceof Element ? target : target.current;

    if (element == null) {
      return;
    }

    if (once && intersectedRef.current) {
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      var entry = entries[entries.length - 1];
      setIntersecting(entry.isIntersecting);

      if (callback != null) {
        callback(entry);
      }

      if (entry.isIntersecting) {
        intersectedRef.current = true;
      }

      if (once && entry.isIntersecting && element != null) {
        observer.unobserve(element);
      }
    }, __assign(__assign({}, optsRef.current), {
      root: optsRef.current.root != null ? optsRef.current.root.current : null
    }));
    observer.observe(element);
    return function () {
      if (once && intersectedRef.current) {
        return;
      }

      if (element != null) {
        observer.unobserve(element);
      }
    };
  }, [optsRef.current, target]);
  return intersecting;
};